import type { SVGProps } from 'react';

const SvgAiSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M4 12c.55 0 1-.45 1-1 0-3.31 2.69-6 6-6 .55 0 1-.45 1-1s-.45-1-1-1c-4.41 0-8 3.59-8 8 0 .55.45 1 1 1m16.71 7.29-3.4-3.4a7.96 7.96 0 0 0 1.61-3.75.995.995 0 0 0-.85-1.13.995.995 0 0 0-1.13.85C16.52 14.79 13.97 17 11 17c-.55 0-1 .45-1 1s.45 1 1 1c1.82 0 3.53-.63 4.89-1.69l3.4 3.4c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zM11 7.5c0 .15.12.26.26.26 2.41 0 3.97 1.56 3.97 3.97 0 .15.12.26.26.26s.26-.12.26-.26c0-2.41 1.56-3.97 3.97-3.97.15 0 .26-.12.26-.26s-.12-.26-.26-.26c-2.41 0-3.97-1.56-3.97-3.97 0-.15-.12-.26-.26-.26s-.26.12-.26.26c0 2.41-1.56 3.97-3.97 3.97-.15 0-.26.12-.26.26m1 7c0-.15-.12-.26-.26-.26-2.41 0-3.97-1.56-3.97-3.97 0-.15-.12-.26-.26-.26s-.26.12-.26.26c0 2.41-1.56 3.97-3.97 3.97-.15 0-.26.12-.26.26s.12.26.26.26c2.41 0 3.97 1.56 3.97 3.97 0 .15.12.26.26.26s.26-.12.26-.26c0-2.41 1.56-3.97 3.97-3.97.15 0 .26-.12.26-.26"
    />
  </svg>
);
export default SvgAiSearch;
